import type { ReactNode } from 'react';

// THE BOX PHASE 1'S INPUTS AND GALLERIES SIT IN — the manual's pages, the listing links, each
// submodel's pictures: one look, so they read as the parts of one phase. The PDF viewer's box
// was the first; the others took its style rather than a second one written beside it.
export const PANEL_CARD =
  'mx-auto w-full max-w-5xl rounded-2xl border border-slate-300 bg-slate-50 shadow-sm';

// AND ITS TITLE, the first row inside it, centred — what the box holds, said before anything
// in it. Placed by the caller: the PDF's box lays its top row out absolutely (a toggle on the
// left, the close button on the right), the listings' box in flow.
export function PanelTitle({ children, className = '' }: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <p className={`flex items-center justify-center text-xs font-semibold uppercase tracking-wide text-slate-500 ${className}`}>
      {children}
    </p>
  );
}
